import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useRef } from "react";
import Modal from "react-bootstrap/Modal";

const LoadingModal: FunctionComponent<{ translate: (code: string) => string; isVisible: boolean }> = observer(
  ({ translate, isVisible }) => {
    const rootRef = useRef<HTMLDivElement>(null);

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const onHide = () => {};

    return (
      <div ref={rootRef}>
        <Modal className="loading-modal-dialog" dialogClassName="loading-modal" show={isVisible} onHide={onHide} centered>
          <Modal.Body className="text-center pb-7">
            <div className="spinner-border text-danger my-4" role="status">
              <span className="sr-only">{translate("loading")}</span>
            </div>
            <h6 className="mb-auto">{translate("loading").toUpperCase()}</h6>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
);

export default LoadingModal;
